// extracted by mini-css-extract-plugin
export default {"glass-effect-wrapper":"wrapper_glass-effect-wrapper__1Y+5e"};